import { configureStore } from "@reduxjs/toolkit"
import { api } from "@/api/base-api"
import { billingCustomerReducer } from "@/store/billing-customer"

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    billingCustomer: billingCustomerReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
